import { Button } from '@/components/ui/button';
import { CottonAnalyticalTable } from '@/features/cotton-analytical/components/CottonAnalyticalTable';
import { useCottonAnalyticalStore } from '@/features/cotton-analytical/store/useCottonAnalyticalStore';
import { exportCottonAnalyticalToExcel } from '@/features/cotton-analytical/utils/exportCottonAnalyticalToExcel';
import { format } from 'date-fns';
import { Download, Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const CottonAnalyticalPage = () => {
  const { t } = useTranslation();
  const { data, loading, fetchCottonAnalytical } = useCottonAnalyticalStore();

  useEffect(() => {
    fetchCottonAnalytical();
  }, []);

  const handleExport = async () => {
    if (data) {
      await exportCottonAnalyticalToExcel(data);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="size-8 animate-spin text-dark-blue" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">{t('no_results')}</p>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col gap-4 p-8"
      style={{ height: 'auto', minHeight: 0 }}
    >
      <div className="flex items-center justify-between flex-shrink-0">
        <div className="flex flex-col">
          <h1 className="text-xl font-bold text-dark-blue">
            {t('cotton.analytical.table')}
          </h1>
          {data.cachedAt && (
            <p className="text-sm text-gray-500 font-medium">
              {t('data.status')}:{' '}
              {format(new Date(data.cachedAt), 'yyyy-MM-dd HH:mm')}
            </p>
          )}
        </div>

        <Button
          onClick={handleExport}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
        >
          <Download className="size-4" />
          Excel
        </Button>
      </div>

      {/* Table */}
      <div className="flex-1 min-h-0">
        <CottonAnalyticalTable data={data} />
      </div>
    </div>
  );
};

export default CottonAnalyticalPage;
